(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-main-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (!root || root.dataset.fsInit === '1') return;
      root.dataset.fsInit = '1';

      const slides = root.querySelectorAll('.fs-slide');
      if (slides.length < 2) return;

      const dots    = root.querySelectorAll('[data-fs-go]');
      const prevBtn = root.querySelector('[data-fs-prev]');
      const nextBtn = root.querySelector('[data-fs-next]');
      const currEl  = root.querySelector('[data-fs-current]');
      const stage   = root.querySelector('.fs-stage');

      const autoplay = root.dataset.autoplay === 'true';
      const duration = parseInt(root.dataset.duration, 10) || 5500;
      root.style.setProperty('--fs-duration', duration + 'ms');

      let current = 0;
      const total = slides.length;
      let timer;

      const pad = n => String(n).padStart(2, '0');

      function go(i) {
        const next = ((i % total) + total) % total;
        if (next === current) return;
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = next;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
        if (currEl) currEl.textContent = pad(current + 1);
        restart();
      }

      const next = () => go(current + 1);
      const prev = () => go(current - 1);

      function restart() {
        clearInterval(timer);
        if (autoplay) timer = setInterval(next, duration);
      }

      if (nextBtn) nextBtn.addEventListener('click', next);
      if (prevBtn) prevBtn.addEventListener('click', prev);
      dots.forEach(dot => dot.addEventListener('click', () => go(parseInt(dot.dataset.fsGo, 10))));


      root.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') next();
        if (e.key === 'ArrowLeft')  prev();
      });

      let startX = 0;
      stage.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend',   e => {
        const diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) (diff > 0 ? prev : next)();
      });

      restart();
    }

    function initAll() {
      document.querySelectorAll('.fashion-slider').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', e => {
      const sec = e.target.querySelector('.fashion-slider');
      if (sec) initSlider(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
